import { CommonModule } from '@angular/common';
import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

import { CircularProgressModule } from '../circular-progress/circular-progress.module';
import { DialogModule } from '../dialog';

export interface LoadingDialogData {
  warningText: string;
}

@Component({
    selector: 'lui-loading-dialog',
    imports: [
        CommonModule,
        DialogModule,
        MatDialogModule,
        CircularProgressModule,
    ],
    templateUrl: './loading-dialog.component.html',
    styleUrls: ['./loading-dialog.component.scss']
})
export class LoadingDialogComponent {
  warningText: string;

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) readonly data: LoadingDialogData
  ) {
    this.warningText = (data && data.warningText) || '';
  }
}
